import React from 'react'
import { WalletSection } from '../widget/WalletSection'

export const Wallet = () => {
    return (
        <div className="wallet-raw section pt10">
            <WalletSection />
        </div>
    )
}